import './NewsFilter.scss';
import template from './NewsFilter.vhtml';
import EventBus from '../eventBus';

export default {
	name: 'NewsFilter',
	template: template,
	props: {
		terms: {
			type: String,
			default: null,
		},
	},
	data: () => ({
		items: null,
		activeTerm: '',
	}),
	computed: {},
	methods: {
		selectTerm(slug) {
			EventBus.$emit('term-filter', slug);
			this.activeTerm = slug;
		},
		getActiveTerm() {
			const currentParams = window.location.search;
			if (currentParams !== '') {
				const termParam = currentParams.split('&')[1];
				const term = termParam.replace('newsterm=', '');
				this.activeTerm = term;
			} else {
				this.activeTerm = '';
			}
		},
		getActiveClass(slug) {
			return this.activeTerm === slug ? 'news-filter__btn--active' : '';
		},
	},
	mounted() {
		this.items = JSON.parse(this.terms);
		this.getActiveTerm();
	},
};
